// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadLicence_container__3y6kC","file":"UploadLicence_file__1LA1X","chooseFile":"UploadLicence_chooseFile__-NnFl"};